import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";

export interface CustomSignInBreadcrumbParams {
    customerTitle: string;
    location: Location;
    history: any;
}


export const buildCustomSignInBreadcrumb = (): IBreadcrumbItem[] => {
    const rootUrl = process.env.REACT_APP_ZedX_Net;

    const items: IBreadcrumbItem[] = [
        {
            text: "ZedX Apps",
            key: "root",
            href: rootUrl,
        },
        {
            text: "Select Account",
            key: "select-account",
            href: rootUrl,
        },
        {
            text: "Login",
            key: "login",
            isCurrentItem: true,
        }
    ];

    return items;
};